module.exports = require('./lib/marvel-ui-avatar.js');



//////////////////
// WEBPACK FOOTER
// ./~/@marvelapp/marvel-ui/avatar.js
// module id = 515
// module chunks = 63239383231690 157636680307020